import { defineStore } from "pinia";
import { APP_STEP } from "./types";
export interface MainState {
    guardStep: APP_STEP;
}

const state: MainState = {
    guardStep: APP_STEP.ABOUT_YOU
};

export const useMainPersistentStore = defineStore("main<persistent>", {
    state: () => state,
    actions: {
        resetStore() {
            this.guardStep = APP_STEP.ABOUT_YOU;
        },
        setGuardStep(step: APP_STEP) {
            console.log("Setting guard step to: ", step);
            this.guardStep = step;
        }
    }
});
